import { render, staticRenderFns } from "./headquarters.vue?vue&type=template&id=efcfea14&scoped=true"
import script from "./headquarters.vue?vue&type=script&lang=ts"
export * from "./headquarters.vue?vue&type=script&lang=ts"
import style0 from "./headquarters.vue?vue&type=style&index=0&id=efcfea14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcfea14",
  null
  
)

export default component.exports